import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import slide1img from '../aseets/images/home/slide1.avif';
import { useTranslation } from 'react-i18next';
import slide3img from '../aseets/images/home/slide3.jpg';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/apiService';

const Login = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginError, setLoginError] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Vérifier si l'utilisateur est déjà connecté
  useEffect(() => {
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    if (isLoggedIn) {
      // Rediriger vers la page d'accueil si déjà connecté
      navigate('/');
    }
  }, [navigate]);

  const inputBaseStyle = {
    padding: '14px 16px',
    border: '1px solid #e9ecef',
    borderRadius: '8px',
    fontSize: '0.95rem',
    outline: 'none',
    width: '100%',
    backgroundColor: '#ffffff',
    transition: 'all 0.3s ease',
    fontFamily: 'inherit'
  };

  const handleFocus = (e) => {
    e.target.style.borderColor = '#96ca2d';
    e.target.style.boxShadow = '0 0 0 3px rgba(150, 202, 45, 0.15)';
    e.target.style.transform = 'translateY(-1px)';
  };

  const handleBlur = (e) => {
    e.target.style.borderColor = '#e9ecef';
    e.target.style.boxShadow = 'none';
    e.target.style.transform = 'translateY(0)';
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    
    // Réinitialiser les erreurs
    setEmailError('');
    setPasswordError('');
    setLoginError('');
    
    let hasError = false;
    if (!email.trim()) { setEmailError(t('login.errors.emailRequired', 'Email requis')); hasError = true; }
    else if (!/^([^\s@]+)@([^\s@]+)\.[^\s@]+$/.test(email)) { setEmailError(t('login.errors.emailInvalid', 'Email invalide')); hasError = true; }
    if (!password.trim()) { setPasswordError(t('login.errors.passwordRequired', 'Mot de passe requis')); hasError = true; }
    if (hasError) return;
    
    setIsLoading(true);
    
    try {
      // Appeler l'API de connexion
      const result = await login(email, password);
      
      if (result && result.success) {
        // Sauvegarder l'état de connexion
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('userEmail', result.data.email);
        localStorage.setItem('userName', result.data.name || 'Admin');
        localStorage.setItem('userRole', result.data.role || 'Administrateur');
        localStorage.setItem('userId', result.data.id);
        
        // Rediriger vers le dashboard admin
        navigate('/admin/dashboard');
      } else {
        setLoginError(t('login.errors.invalidCredentials', 'Identifiants incorrects'));
      }
    } catch (error) {
      setLoginError(error.message || t('login.errors.connectionError', 'Erreur de connexion. Veuillez réessayer.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059"><div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type"><div class="jet-theme-core-document__inner">
	
	<Navbar/>
	
	{/* Composant de test des icônes FontAwesome */}
	
	<article id="post-4059" class="post-4059 page type-page status-publish hentry">	
			<div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
				<section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;5759a04&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
					<div class="elementor-container elementor-column-gap-default">
						<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
							<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-settings="{&quot;slider_height&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:852,&quot;sizes&quot;:[]},&quot;_animation&quot;:&quot;none&quot;,&quot;slider_height_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:650,&quot;sizes&quot;:[]},&quot;slider_height_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:500,&quot;sizes&quot;:[]}}" data-widget_type="jet-slider.default">
									<div class="elementor-widget-container">
										<div class="elementor-jet-slider jet-elements">
											<div style={{ position: 'relative', width: '100%', height: '330px', overflow: 'hidden' }}>
												<img 
													src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
													alt="Innovation technologique et sécurité digitale" 
													style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} 
												/>
												<div style={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.45)' }} />
												<div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
													<div style={{ background: 'rgba(0,0,0,0.45)', padding: '16px 24px', borderRadius: '12px', boxShadow: '0 10px 30px rgba(0,0,0,0.25)', backdropFilter: 'blur(2px)', maxWidth: '960px', width: '100%' }}>
														<h1 style={{ color: '#fff', fontSize: 'clamp(28px,5vw,46px)', fontWeight: 800, margin: 0, textAlign: 'center', letterSpacing: '0.5px' }}>{t('login.heroTitle', 'Connexion')}
                                                        </h1>
                                                        

                                                     
														
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</section>
</div>
                    </article>
        

          {/* Login Form Section */}
          <section 
            style={{
              padding: '40px 20px 0px 20px',
            }}
          >
            <div 
              style={{
                maxWidth: '550px',
                margin: '0 auto',
                position: 'relative'
              }}
            >
              {/* Decorative elements */}
              <div 
                style={{
                  position: 'absolute',
                  top: '-20px',
                  left: '-20px',
                  width: '40px',
                  height: '40px',
                  background: '#96ca2d',
                  borderRadius: '50%',
                  opacity: 0.1
                }}
              />
              <div 
                style={{
                  position: 'absolute',
                  bottom: '-20px',
                  right: '-20px',
                  width: '60px',
                  height: '60px',
                  background: '#96ca2d',
                  borderRadius: '50%',
                  opacity: 0.1
                }}
              />

              <div 
                style={{
                  background: '#ffffff',
                  borderRadius: '20px',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                  padding: '40px',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                {/* Header */}
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                  <div 
                    style={{
                      width: '60px',
                      height: '60px',
                      background: 'linear-gradient(135deg, #96ca2d, #7fb069)',
                      borderRadius: '50%',
                      margin: '0 auto 16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 8px 20px rgba(150, 202, 45, 0.3)'
                    }}
                  >
                    <i 
                      className="fas fa-user" 
                      style={{ 
                        color: 'white', 
                        fontSize: '24px' 
                      }}
                    />
                  </div>
                  <h2 
                    style={{
                      margin: '0 0 8px 0',
                      fontSize: '28px',
                      fontWeight: '700',
                      color: '#212529'
                    }}
                  >
                    {t('login.welcome', 'Bienvenue')}
                  </h2>
                  <p 
                    style={{
                      margin: '0',
                      color: '#6c757d',
                      fontSize: '16px'
                    }}
                  >
                    {t('login.subtitle', 'Connectez-vous à votre compte')}
                  </p>
                </div>

                {/* Message d'information pour les administrateurs */}
                <div style={{ 
                  background: '#fff3cd', 
                  color: '#856404', 
                  padding: '12px 16px', 
                  borderRadius: '8px', 
                  marginBottom: '20px',
                  border: '1px solid #ffc107',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  fontSize: '14px',
                  fontWeight: '500'
                }}>
                  <i className="fas fa-shield-alt" style={{ fontSize: '16px' }} />
                  <span>{t('login.adminOnly', 'Cet espace est réservé aux administrateurs uniquement')}</span>
                </div>

                {/* Message d'erreur de connexion */}
                {loginError && (
                  <div style={{ 
                    background: '#f8d7da', 
                    color: '#721c24', 
                    padding: '10px 14px', 
                    borderRadius: '6px', 
                    marginBottom: '20px',
                    border: '1px solid #f5c6cb',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    fontSize: '14px'
                  }}>
                    <i className="fas fa-exclamation-triangle" />
                    {loginError}
                  </div>
                )}

                <form onSubmit={onSubmit} style={{ display: 'grid', gap: '20px' }}>
                  <div>
                    <label 
                      style={{ 
                        display: 'block', 
                        marginBottom: '8px', 
                        fontWeight: '600', 
                        color: '#212529',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      <i className="fas fa-envelope" style={{ marginRight: '8px', color: '#96ca2d' }} />
                      {t('login.email', 'Adresse Email')}
                    </label>
                     <input
                       type="email"
                       value={email}
                       onChange={(e) => { 
                         setEmail(e.target.value);
                         // Effacer l'erreur de connexion quand l'utilisateur tape
                         if (loginError) setLoginError('');
                         // Vérifier le format de l'email en temps réel
                         if (e.target.value.trim()) {
                           if (/^([^\s@]+)@([^\s@]+)\.[^\s@]+$/.test(e.target.value)) {
                             setEmailError(''); // Email valide, effacer l'erreur
                           } else {
                             setEmailError(t('login.errors.emailFormat', 'Format d\'email incorrect')); // Email invalide, afficher erreur
                           }
                         } else {
                           setEmailError(''); // Champ vide, effacer l'erreur
                         }
                       }}
                       placeholder={t('login.emailPlaceholder', 'votre@email.com')}
                       style={{ 
                         ...inputBaseStyle, 
                         border: `2px solid ${emailError ? '#dc3545' : '#e9ecef'}`,
                         background: emailError ? '#fff5f5' : '#ffffff'
                       }}
                       onFocus={handleFocus}
                       onBlur={handleBlur}
                     />
                    {emailError && (
                      <div style={{ 
                        color: '#dc3545', 
                        fontSize: '0.85rem', 
                        marginTop: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <i className="fas fa-exclamation-circle" />
                        {emailError}
                      </div>
                    )}
                  </div>

                  <div>
                    <label 
                      style={{ 
                        display: 'block', 
                        marginBottom: '8px', 
                        fontWeight: '600', 
                        color: '#212529',
                        fontSize: '14px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px'
                      }}
                    >
                      <i className="fas fa-lock" style={{ marginRight: '8px', color: '#96ca2d' }} />
                      {t('login.password', 'Mot de passe')}
                    </label>
                     <input
                       type="password"
                       value={password}
                       onChange={(e) => { 
                         setPassword(e.target.value);
                         // Effacer l'erreur de connexion quand l'utilisateur tape
                         if (loginError) setLoginError('');
                         // Effacer l'erreur si le mot de passe devient valide
                         if (passwordError && e.target.value.trim()) {
                           setPasswordError('');
                         }
                       }}
                       placeholder={t('login.passwordPlaceholder', 'Votre mot de passe')}
                       style={{ 
                         ...inputBaseStyle, 
                         border: `2px solid ${passwordError ? '#dc3545' : '#e9ecef'}`,
                         background: passwordError ? '#fff5f5' : '#ffffff'
                       }}
                       onFocus={handleFocus}
                       onBlur={handleBlur}
                     />
                    {passwordError && (
                      <div style={{ 
                        color: '#dc3545', 
                        fontSize: '0.85rem', 
                        marginTop: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px'
                      }}>
                        <i className="fas fa-exclamation-circle" />
                        {passwordError}
                      </div>
                    )}
                  </div>

                 

                  <button
                    type="submit"
                    disabled={isLoading}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '10px',
                      padding: '14px 24px',
                      borderRadius: '12px',
                      background: isLoading ? '#9ca3af' : 'linear-gradient(135deg, #96ca2d, #7fb069)',
                      color: '#fff',
                      border: 'none',
                      fontWeight: '600',
                      fontSize: '16px',
                      transition: 'all 0.3s ease',
                      cursor: isLoading ? 'not-allowed' : 'pointer',
                      marginTop: '12px',
                      boxShadow: isLoading ? 'none' : '0 4px 15px rgba(150, 202, 45, 0.3)',
                      textTransform: 'uppercase',
                      letterSpacing: '0.5px',
                      opacity: isLoading ? 0.7 : 1
                    }}
                    onMouseEnter={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.background = '#ffffff';
                        e.currentTarget.style.color = '#96ca2d';
                        e.currentTarget.style.border = '2px solid #96ca2d';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(150, 202, 45, 0.4)';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isLoading) {
                        e.currentTarget.style.background = 'linear-gradient(135deg, #96ca2d, #7fb069)';
                        e.currentTarget.style.color = '#fff';
                        e.currentTarget.style.border = 'none';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(150, 202, 45, 0.3)';
                      }
                    }}
                  >
                    {isLoading ? (
                      <>
                        <i className="fas fa-spinner fa-spin" />
                        {t('login.loggingIn', 'Connexion...')}
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt" />
                        {t('login.loginButton', 'Se connecter')}
                      </>
                    )}
                  </button>
                </form>

               
              </div>
            </div>
          </section>

          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Login;

